import * as React from 'react';
import { Helmet } from 'react-helmet';

export interface DocTitleProperties {
  title: string;
}

export class DocTitleComponent extends React.Component<DocTitleProperties> {
  constructor(props: DocTitleProperties) {
    super(props);
  }

  render() {
    const title = typeof this.props.title === 'undefined' ? 'FNHW' : `FNHW - ${this.props.title}`;
    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        {this.props.children}
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/DocTitle.tsx